import Vue from 'vue'
import vueRouter from 'vue-router'
import App from './App.vue'
import 'animate.css'
import { routes } from './router/index'
import { store } from './store/index'
import MyPlugin from './GlobalPlugin'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import VueSweetalert2 from 'vue-sweetalert2'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import 'sweetalert2/dist/sweetalert2.min.css'
import ImageUploader from 'vue-image-upload-resize'
import VueSession from 'vue-session'
import TreeT from 'vue-ads-table-tree'
import vueshortkey from 'vue-shortkey'
import VueIframe from 'vue-iframes'
import WebCam from 'vue-web-cam'
import Paintable from 'vue-paintable'
import VueTheMask from 'vue-the-mask'
import VueApexCharts from 'vue-apexcharts'
import excel from 'vue-excel-export'
import Spinner from 'vue-spinkit'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import appsetting from '../public/appsettings.json'
import './registerServiceWorker'
import './registerServiceWorker'
import VueNativeNotification from 'vue-native-notification'
import VueCookies from 'vue-cookies'

Vue.use(VueReCaptcha, { siteKey: appsetting.CaptchSiteKey })
Vue.component('Spinner', Spinner)
Vue.use(excel)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(VueTheMask)
Vue.use(VueIframe)
Vue.use(TreeT)
Vue.use(VueSession)
Vue.use(ImageUploader)
Vue.component('date-picker', VuePersianDatetimePicker)
Vue.use(vueRouter)
Vue.use(VueSweetalert2)
Vue.component('vue-bootstrap4-table', VueBootstrap4Table)
Vue.use(MyPlugin)
Vue.use(vueshortkey)
Vue.use(WebCam)
Vue.use(Paintable, {
  // optional methods
  setItem(key, image) {
    localStorage.setItem(key, image)
  },
  // you also can use async
  getItem(key) {
    return localStorage.getItem(key)
  },
  removeItem(key) {
    localStorage.removeItem(key)
  },
})
Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true,
})
Vue.use(VueCookies, { expire: '7d' })
const router = new vueRouter({
  routes,
  mode: 'history',
})
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
